import CardAppointmentLoading from './card-appointment/variants/_components/appointment-loading.component';

import { Skeleton } from '@/components/ui/skeleton.component';

export function AppointmentsLoading() {
  return (
    <div className="w-full flex flex-col gap-4 items-center">
      <div className="inline-flex items-center gap-1 rounded-lg border border-gray-300 bg-gray-100 p-1">
        <Skeleton className="h-9 w-24 rounded-sm" />
        <Skeleton className="h-9 w-24 rounded-sm" />
        <Skeleton className="h-9 w-24 rounded-sm" />
      </div>
      <CardAppointmentLoading isOpen={false} />
      <CardAppointmentLoading isOpen={false} />
      <Skeleton className="h-12 mx-auto w-full md:max-w-3xl" />
    </div>
  );
}
